export const OFFERS_ON_PAGE = 28;
export const BANNER_POSITIONS = [7, 34, 64];
export const trackingReasonToListingType = {
  pin_click: 'map',
  all_objects_on_map: 'list',
};
